import Vue from 'vue';
import * as dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';


dayjs.extend(customParseFormat);

Object.defineProperties(Vue.prototype, {
    $date: {
        get() {
            return dayjs;
        },
    },
});
